import React, {useEffect, useMemo, useState} from "react";
import { NavLink, useNavigate } from "react-router-dom";

import RegisterWrapper from "../../Components/Wrappers/RegisterWrapper";
import Button from "../../UI/Button";
import useCountriesApi from "../../Global/Api/Signup/countriesApi";
import {useDispatch, useSelector} from "react-redux";
import { setSelectedBusinessUnit} from "../../Store/Slice/registerSlice";

export default function SelectCountry() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { businessUnits, selectedBusinessUnit } = useSelector((state) => state.rootReducer.registerSlice);
  const [isButtonClickable, setIsButtonClickable] = useState(false);
  const { fetchBusinessUnits } = useCountriesApi();

  useEffect(() => {
    fetchBusinessUnits();
  }, [])
  const handleSubmit = (event) => {
    event.preventDefault();
    navigate("/register");
  };

  const selectBusinessUnit = (bu) => {
    if (bu?.id === selectedBusinessUnit?.id) {
      dispatch(setSelectedBusinessUnit({}));
      localStorage.setItem("businessId", null);
      setIsButtonClickable(false);
    } else {
      dispatch(setSelectedBusinessUnit(bu));
      localStorage.setItem("businessId", bu?.id);
      setIsButtonClickable(true);
    }
  };

  useEffect(() => {
    if (localStorage.getItem("techsbook_customer_portal_token")?.length > 0) {
      navigate("/");
    }
  }, []);

  return (
    <RegisterWrapper image="/assets/images/register-3.svg">
      <h1 className="register__title">Welcome to Techsbook!</h1>
      <div className="mt24 form-description">Select business unit</div>
      <form onSubmit={handleSubmit} className="register__form mt24">
        <div className="select-country">
          {
            businessUnits.map((item, index) => (
              <div
                key={index}
                className={`select-country__card ${selectedBusinessUnit?.id === item?.id ? 'select-country__card-active' : ''}`}
                onClick={() => selectBusinessUnit(item)}>
                <span className="select-country__card-name">{item?.company_name}</span>
                <div className="select-country__card-country">
                  <span>{item?.country?.name}</span>
                  <img className="select-country__card-image" src={item?.country?.image_url} alt={item?.country?.name}/>
                </div>
              </div>
            ))
          }
        </div>
        <div className="register__btn mt24">
          <Button
            text="Get started"
            type="primary"
            disabled={!isButtonClickable}
            topPadding={12}
            bottomPadding={12}
          />
        </div>
      </form>
      <div className="register__footer mt24">
        Already have an account?{" "}
        <NavLink to="/login" className="register__link">
          Log in
        </NavLink>
      </div>
    </RegisterWrapper>
  );
}
